<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="Quick Survey"
  [nzOkText]="'Submit'"
  [nzOkDisabled]="rate === undefined"
  (nzOnOk)="handleOk()"
  [nzCancelText]="null"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzCloseOnNavigation]="false"
  [nzCancelDisabled]="true"
>
  <ng-container *nzModalContent>
    <div class="vertical-large center">
      <div>How satisfied are you with 360Interview AI's assistance during this interview?</div>

      <div class="vertical rating">
        <nz-segmented [nzOptions]="rateList" (nzValueChange)="handleIndexChange($event)"></nz-segmented>
        <div class="horizontal seperate">
          <div>Dissatisfied</div>
          <div>Satisfied</div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
